import classNames from 'classnames';

// styles
import s from './InputLabel.sss';

// types
interface InputLabelProps extends React.HTMLProps<HTMLLabelElement> {
  required?: boolean;
  disabled?: boolean;
  className?: string;
}

export const InputLabel: React.FC<InputLabelProps> = ({
  required,
  disabled,
  className,
  ...props
}) => (
  <label
    {...props}
    className={classNames(
      s.root,
      className,
      { [s.required]: required },
      { [s.disabled]: disabled },
    )}
  />
);

export default InputLabel;
